import loadable from "@loadable/component"
import { DeployNowWizardProps } from "@modules/site/create/DeployNow/components/DeployNowWizard"
import { ShopifyAppSiteCreationTypePickerProps } from "@modules/site/create/ShopifyApp/shared/ShopifyAppSiteCreationTypePicker"
import { ShopifyAppImportSiteWizardProps } from "@modules/site/create/ShopifyApp/Import/ShopifyAppImportSiteWizard"

export { SiteCreationTypePicker } from "@modules/site/create/SiteCreationTypePicker"
export { SiteConfiguration } from "@modules/site/create/Import/components/SiteConfiguration"
export { ProvisionConfiguration } from "@modules/site/create/Provision/components/ProvisionConfiguration"

export const DeployNowWizard = loadable<DeployNowWizardProps>(() =>
  import(
    /* webpackChunkName: "deploynow-site-chunk" */
    /* webpackPrefetch: true */
    "@modules/site/create/DeployNow/components/DeployNowWizard"
  ).then(mod => mod.DeployNowWizard)
)

export const ShopifyAppSiteCreationTypePicker = loadable<
  ShopifyAppSiteCreationTypePickerProps
>(() =>
  import(
    /* webpackChunkName: "creationtype-site-chunk" */
    /* webpackPrefetch: true */
    "@modules/site/create/ShopifyApp/shared/ShopifyAppSiteCreationTypePicker"
  ).then(mod => mod.ShopifyAppSiteCreationTypePicker)
)

export const ShopifyAppImportSiteWizard = loadable<
  ShopifyAppImportSiteWizardProps
>(() =>
  import(
    /* webpackChunkName: "import-site-chunk" */
    /* webpackPrefetch: true */
    "@modules/site/create/ShopifyApp/Import/ShopifyAppImportSiteWizard"
  ).then(mod => mod.ShopifyAppImportSiteWizard)
)
